export function currencySymbol(currency) {
	switch (currency) {
		case 'gbp':
			currency = '\u00A3'
			break
		case 'chf':
			currency = 'CHF'
			break
		case 'eur':
			currency = '\u20ac'
			break
		default:
			currency = '$'
			break
	}
	return currency
}

export function getAvatarName(name) {
	const arr = name.split(' ')
	const regex = /^[\w\d]+$/
	let tmp = []
	arr.map(str => {
		if (regex.test(str)) {
			tmp[tmp.length] = str
		}
		return ''
	})
	if (tmp.length === 0) {
		tmp = arr
	}

	let result = ''
	if (tmp.length > 0) {
		result = tmp[0].charAt(0)
		if (tmp[1]) {
			result += tmp[1].charAt(0)
		} else {
			result += tmp[0].charAt(1)
		}
	}
	return result.toUpperCase()
}

export const formatCurrency = (currency, value) => {
	// return `${currencySymbol(currency)}${(Math.round(value * 100) / 100).toFixed(2)}`;
	return `${currencySymbol(currency)}${((value * 100) / 100).toFixed(2)}`
}

export const numberFormatCurrency = (currency, value) => {
	const formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency,
		minimumFractionDigits: 2,
	})
	return formatter.format(value)
}
